/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useMemo, useCallback } from 'react';
import { getBaseUrl } from '../../Account-managementApiEnvironment';
import { useMutation, ErrorTypes } from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseEngUsersAccountManagementApiApiExportWorkspaceAuditEventsRequest,
  getCoinbaseEngUsersAccountManagementApiApiExportWorkspaceAuditEventsRequestErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiExportWorkspaceAuditEventsRequest';
import {
  CoinbaseEngUsersAccountManagementApiApiExportWorkspaceAuditEventsResponse,
  getCoinbaseEngUsersAccountManagementApiApiExportWorkspaceAuditEventsResponseErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiExportWorkspaceAuditEventsResponse';

type ExportWorkspaceAuditEventsMutationArgs =
  CoinbaseEngUsersAccountManagementApiApiExportWorkspaceAuditEventsRequest;

export type ExportWorkspaceAuditEventsResult =
  CoinbaseEngUsersAccountManagementApiApiExportWorkspaceAuditEventsResponse;

const validateExportWorkspaceAuditEventsResult = (value: unknown) => {
  const errors =
    getCoinbaseEngUsersAccountManagementApiApiExportWorkspaceAuditEventsResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: ExportWorkspaceAuditEventsResult data does not match contract.`,
      errors,
    );
  }
};

type HookReturnType = (
  payload: Readonly<ExportWorkspaceAuditEventsMutationArgs>,
  options?: RequestInit,
) => Promise<ExportWorkspaceAuditEventsResult | ErrorTypes>;

export const getExportWorkspaceAuditEventsUrl = () => {
  const searchParams = new URLSearchParams();
  const url = `${getBaseUrl()}/organization/v1/workspace/audit-events/export${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Post ExportWorkspaceAuditEvents
 * @Url /organization/v1/workspace/audit-events/export
 * @Auth Required
 */
export const useExportWorkspaceAuditEvents = (): HookReturnType => {
  const mutation = useMutation<unknown, ExportWorkspaceAuditEventsResult>();

  const callback = useCallback(
    async (payload: Readonly<ExportWorkspaceAuditEventsMutationArgs>, options?: RequestInit) => {
      const postBody = {
        organization_id: payload.organizationId,
        start_time: payload.startTime,
        end_time: payload.endTime,
        actor_ids: payload.actorIds,
        event_types: payload.eventTypes,
        target_id: payload.targetId,
        legal_entity_id: payload.legalEntityId,
        outcome: payload.outcome,
        correlation_id: payload.correlationId,
        search: payload.search,
        format: payload.format,
      };

      const init = { ...(options || {}), method: 'POST' };

      const url = getExportWorkspaceAuditEventsUrl();
      const result = await mutation(url, postBody, init);
      if (process.env.NODE_ENV !== 'production') {
        validateExportWorkspaceAuditEventsResult(result);
      }
      return result;
    },
    [mutation],
  );

  return callback;
};
